import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "fieldcustomeditor",
  class: "col-sm-12"
}
const _hoisted_2 = ["name"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "col-sm-2 control-label input-sm" }
const _hoisted_5 = { class: "col-sm-9" }
const _hoisted_6 = ["onUpdate:modelValue", "onChange", "data-testid"]
const _hoisted_7 = { class: "col-sm-1" }
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "col-sm-10 col-sm-offset-2 help-block"
}
const _hoisted_10 = {
  class: "help-block",
  "data-testid": "field-description-help"
}
const _hoisted_11 = {
  class: "row",
  style: {"padding-left":"30px !important"}
}
const _hoisted_12 = { class: "col-md-10" }
const _hoisted_13 = {
  key: 0,
  class: "form"
}
const _hoisted_14 = {
  class: /*@__PURE__*/_normalizeClass(['form-data'])
}
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "col-md-8" }
const _hoisted_17 = {
  class: /*@__PURE__*/_normalizeClass(['form-data'])
}
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "col-md-8" }
const _hoisted_20 = { class: "help-block" }
const _hoisted_21 = {
  key: 1,
  class: "form"
}
const _hoisted_22 = {
  class: /*@__PURE__*/_normalizeClass(['form-group'])
}
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "col-md-8" }
const _hoisted_25 = {
  class: /*@__PURE__*/_normalizeClass(['form-group'])
}
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "col-md-8" }
const _hoisted_28 = {
  class: /*@__PURE__*/_normalizeClass(['form-group'])
}
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "col-md-8" }
const _hoisted_31 = { class: "help-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_alert = _resolveComponent("alert")!
  const _component_pt_select = _resolveComponent("pt-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref: "hiddenFieldInput",
      type: "hidden",
      name: _ctx.name
    }, null, 8, _hoisted_2),
    _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
    (_ctx.customFields != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields, (field, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['form-group']),
              "data-testid": "field-item"
            }, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(field.label || field.key), 1),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  type: "text",
                  class: _normalizeClass(['form-control', 'input-sm', 'context_var_autocomplete']),
                  size: "100",
                  onChange: ($event: any) => (_ctx.changeField(field)),
                  "data-testid": 'field-input-' + index
                }, null, 40, _hoisted_6), [
                  [_vModelText, field.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: "btn btn-xs btn-default",
                  title: _ctx.$t('message_delete'),
                  onClick: ($event: any) => (_ctx.removeField(field)),
                  "data-testid": "remove-field-button"
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "glyphicon glyphicon-remove" }, null, -1)
                ]))], 8, _hoisted_8)
              ]),
              (field.desc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(field.desc), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_btn, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNewField())),
      "data-testid": "add-field-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("message_addField")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_modal, {
      id: "modal-demo",
      ref: "modal",
      modelValue: _ctx.modalAddField,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalAddField) = $event)),
      title: "Add Field",
      "ok-text": "Save",
      backdrop: true,
      "dismiss-btn": true,
      keyboard: true,
      "cancel-text": "Close",
      "append-to-body": "",
      "data-testid": "modal-title"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-default reset_page_confirm",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalAddField = false)),
            "data-testid": "cancel-button"
          }, _toDisplayString(_ctx.$t("message_cancel")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-cta reset_page_confirm",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addField())),
            "data-testid": "confirm-add-field-button"
          }, _toDisplayString(_ctx.$t("message_add")), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.duplicate)
            ? (_openBlock(), _createBlock(_component_alert, {
                key: 0,
                type: "warning",
                "data-testid": "duplicate-warning",
                ref: "duplicateWarningRef"
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("b", null, "Warning!", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("message_duplicated")) + ".", 1)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.useOptions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("message_select")), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_pt_select, {
                        modelValue: _ctx.selectedField,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedField) = $event)),
                        options: _ctx.customOptions,
                        "option-label": "label",
                        filter: true,
                        placeholder: _ctx.$t('message_select'),
                        "append-to": "self",
                        "data-testid": "multiselect"
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("message_description")), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newFieldDescription) = $event)),
                        type: "text",
                        class: _normalizeClass(['form-control']),
                        "data-testid": "field-description-input"
                      }, null, 512), [
                        [_vModelText, _ctx.newFieldDescription]
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("message_empty")), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.useOptions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("message_fieldLabel")), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newLabelField) = $event)),
                        type: "text",
                        class: _normalizeClass(['form-control']),
                        "data-testid": "field-label-input"
                      }, null, 512), [
                        [_vModelText, _ctx.newLabelField]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("message_fieldKey")), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newField) = $event)),
                        type: "text",
                        class: _normalizeClass(['form-control']),
                        "data-testid": "field-key-input"
                      }, null, 512), [
                        [_vModelText, _ctx.newField]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("message_description")), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newFieldDescription) = $event)),
                        type: "text",
                        class: _normalizeClass(['form-control']),
                        "data-testid": "field-description-input"
                      }, null, 512), [
                        [_vModelText, _ctx.newFieldDescription]
                      ]),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("message_empty")), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}